import { render, staticRenderFns } from "./LogOutPage.vue?vue&type=template&id=6ff8bafd"
import script from "./LogOutPage.vue?vue&type=script&lang=js"
export * from "./LogOutPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports